var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKybIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 19",
    width: 14,
    height: 19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 14,
    height: 19,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAATCAMAAACX3symAAAAAXNSR0IB2cksfwAAALRQTFRFAj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+Aj5+/ImnEQAAADx0Uk5TAC6Z2e3Rih1c9v/14fzmPTb6+3MYCCCL6By0Zo0V3wQb+NQDu+sPf95+gu9krulpLYT9psytQZjq8qDcamWVBAAAAIpJREFUeJxtztcOwjAMheEDpC0xFFr2LJRVwt7z/d8LE5CSSv0vLH2+cAJwuXxBOK6HX0VJpbJPlapWENbqjWarTZ3ulz3q6/WAXJ5DGY00x/FkypNm/xvRHFgktFQJp1ZrucGWrGIImwK7TPo25f5wPBme+ZmL4ZXpGIbqds+8/Egz9Y0nXsLq/QGs5A6IAeruLgAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKybIcon);
export default __webpack_public_path__ + "static/media/kybIcon.eb18cd94c1a7bbaa8b556bd59bd16385.svg";
export { ForwardRef as ReactComponent };